module.exports = __webpack_public_path__ + "img/Corporate.edf111ac.png";